import { Helmet } from 'react-helmet-async';
import { absoluteUrl } from '@/lib/seo';

export function ConstructionCompanySchema() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'ConstructionCompany',
    name: 'AST Construction',
    url: absoluteUrl('/'),
    telephone: '0212228130',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Jaffna',
      addressRegion: 'Northern Province',
      addressCountry: 'LK',
      streetAddress: '33, Adiyapatham Road, Thirunelvely',
    },
    areaServed: 'Jaffna, Sri Lanka',
    logo: absoluteUrl('/favicon.png'),
    image: absoluteUrl('/favicon.png'),
    description: 'AST Construction is a premier construction company in Jaffna, providing quality residential, commercial, and industrial engineering solutions.',
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}
